exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ideapage-cssmodule-ideapage-component-1werr{padding-bottom:10px;border:none}.ideapage-cssmodule-form-container-1cvGm{padding-top:10px}", ""]);

// exports
exports.locals = {
	"ideapage-component": "ideapage-cssmodule-ideapage-component-1werr",
	"form-container": "ideapage-cssmodule-form-container-1cvGm"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/MakeIdeas/ideapage.cssmodule.scss
// module id = 605
// module chunks = 0